import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { LORAX, LORAX_LIGHT } from 'HubStyleTokens/colors';
import { getIsPastRefreshThreshold } from './utils/RefreshButton';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRefreshIcon = styled(UIIconButton).withConfig({
  displayName: "RefreshButton__StyledRefreshIcon",
  componentId: "sc-8oz4ev-0"
})(["border:1px solid ", " !important;background-color:", " !important;"], LORAX, LORAX_LIGHT);
const RefreshButton = ({
  timestamp,
  threshold,
  onRefresh
}) => {
  const shouldShowRefreshButton = getIsPastRefreshThreshold({
    date: timestamp,
    threshold
  });
  if (!shouldShowRefreshButton) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledRefreshIcon, {
    className: "m-right-4",
    "data-test-id": "refresh-button",
    onClick: onRefresh,
    size: "xs",
    use: "transparent",
    children: /*#__PURE__*/_jsx(UIIcon, {
      color: LORAX,
      name: "refresh",
      size: "xxs"
    })
  });
};
export default RefreshButton;